module.exports = __webpack_public_path__ + "img/event-solo-venere-janv-mars-2025.1f7d5e5.jpg";